import { render } from "./Index.vue?vue&type=template&id=2732321d"
const script = {}
script.render = render

export default script